const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ADMIN_ABEX_ENDPOINT = `${API_BASE_URL}/api/admin/reference-data/abex/`;

export class AbexApiError extends Error {
  constructor(message, status, data = null) {
    super(message);
    this.name = "AbexApiError";
    this.status = status;
    this.data = data;
  }
}

async function parseJsonSafely(response) {
  const text = await response.text();

  if (!text) {
    return null;
  }

  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}

function resolveErrorMessage(data, fallbackMessage) {
  if (!data) {
    return fallbackMessage;
  }

  if (typeof data.detail === "string") {
    return data.detail;
  }

  if (typeof data.message === "string") {
    return data.message;
  }

  if (Array.isArray(data.non_field_errors) && data.non_field_errors.length) {
    return data.non_field_errors[0];
  }

  return fallbackMessage;
}

export async function getAdminAbexIndex(accessToken) {
  const response = await fetch(ADMIN_ABEX_ENDPOINT, {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const data = await parseJsonSafely(response);

  if (!response.ok) {
    throw new AbexApiError(
      resolveErrorMessage(data, "Could not retrieve ABEX data."),
      response.status,
      data,
    );
  }

  return data;
}

export async function createAdminAbexIndex(accessToken, payload) {
  const response = await fetch(ADMIN_ABEX_ENDPOINT, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  const data = await parseJsonSafely(response);

  if (!response.ok) {
    throw new AbexApiError(
      resolveErrorMessage(data, "Could not create the ABEX value."),
      response.status,
      data,
    );
  }

  return data;
}
